import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import zhTw from 'element-plus/dist/locale/zh-tw.mjs';
import 'element-plus/dist/index.css';
import { router } from './router';
import { i18n } from './i18n';
import App from './App.vue';
import './styles/main.css';

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(i18n);
app.use(ElementPlus, { locale: zhTw });

app.mount('#app');
